import { TabPanel } from '@mui/lab';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { Protect } from 'app/components';
import { MapTransportFlightList } from 'app/pages/Map';
import React from 'react';

const TabPanelFlight = ({ transportSelectedItem, isFetchConditionLoading }) => {
  return (
    <TabPanel value='flight'>
      {['onlyWialon'].includes(config.transportDeviceTypes[transportSelectedItem.device_type]) ? (
        <React.Fragment>
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={(theme) => ({
              width: '100%',
              height: '100%',
              padding: theme.spacing(2),
            })}>
            <Typography align='center' variant='body1' component='span'>
              Раздел недоступен
            </Typography>
            <Typography align='center' color='text.secondary' variant='caption' component='span'>
              Для текущего типа транспортного средства раздел недоступен
            </Typography>
          </Stack>
        </React.Fragment>
      ) : (
        <Protect
          permissions='read'
          renderPermitted={() => (
            <React.Fragment>
              {!isFetchConditionLoading && (
                <Stack
                  direction='row'
                  sx={{
                    height: '100%',
                    bgcolor: 'background.paper',
                  }}>
                  <MapTransportFlightList
                    renderEmpty={() => (
                      <Stack
                        direction='column'
                        alignItems='center'
                        justifyContent='center'
                        sx={(theme) => ({
                          width: '100%',
                          height: '100%',
                          padding: theme.spacing(2),
                        })}>
                        <Typography align='center' variant='body1' component='span'>
                          Здесь пока ничего нет
                        </Typography>
                        <Typography align='center' color='text.secondary' variant='caption' component='span'>
                          В этом разделе будут находиться рейсы транспортного средства
                        </Typography>
                      </Stack>
                    )}
                  />
                </Stack>
              )}
              {isFetchConditionLoading && (
                <Stack
                  direction='column'
                  alignItems='center'
                  justifyContent='center'
                  sx={(theme) => ({
                    width: '100%',
                    height: '100%',
                    padding: theme.spacing(2),
                  })}>
                  <CircularProgress size={24} />
                </Stack>
              )}
            </React.Fragment>
          )}
          renderForbidden={() => (
            <React.Fragment>
              <Stack
                direction='column'
                alignItems='center'
                justifyContent='center'
                sx={(theme) => ({
                  width: '100%',
                  height: '100%',
                  padding: theme.spacing(2),
                })}>
                <Typography align='center' variant='body1' component='span'>
                  Доступ ограничен
                </Typography>
                <Typography align='center' color='text.secondary' variant='caption' component='span'>
                  Под вашей учетной записью доступ ограничен
                </Typography>
              </Stack>
            </React.Fragment>
          )}
        />
      )}
    </TabPanel>
  );
};
export default TabPanelFlight;
